var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3569 2C6.85693 2 2.35693 6.5 2.35693 12C2.35693 17.5 6.85693 22 12.3569 22C17.8569 22 22.3569 17.5 22.3569 12C22.3569 6.5 17.8569 2 12.3569 2ZM10.3569 17L5.35693 12L6.76693 10.59L10.3569 14.17L17.9469 6.58L19.3569 8L10.3569 17Z",
    fill: "#67B926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrue);
export default __webpack_public_path__ + "static/media/true.33cd48850784eea37ea22503b98cc52d.svg";
export { ForwardRef as ReactComponent };